import { render, staticRenderFns } from "./pay-records.vue?vue&type=template&id=a4de940e&"
import script from "./pay-records.vue?vue&type=script&lang=ts&"
export * from "./pay-records.vue?vue&type=script&lang=ts&"
import style0 from "./pay-records.vue?vue&type=style&index=0&id=a4de940e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports